import ar from './ar'
import en from './en'
import id from './id'
import ja from './ja'
import ko from './ko'
import ru from './ru'
import th from './th'
import zh_TW from './zh_TW'

import de from './de';
import fr from './fr';
import it from './it';
import es_ES from './es_ES';
import es_MX from './es_MX';
import pt from './pt';
import tr from './tr';

import hi from './hi';
import pl from './pl';

import vi from './vi';

import zh_CN from './zh_CN';

const l10n: Record<Lang, I18NCookieSetLayerTextData> = { ar, en, id, ja, ko, ru, th, zh_TW, zh_CN, de, fr, it, es_ES, es_MX, pt, tr, hi, pl, vi }
export default l10n
